<template>
  <el-dialog :visible.sync="show" :title="$t('m.audit_trail')" :close-on-click-modal="false" :append-to-body="true">
    <div class="overline">
      <el-table :data="tableData" v-loading="loading.table" border>
        <el-table-column :label="$t('m.apply_time')" prop="applyTime"></el-table-column>
        <el-table-column :label="$t('m.termination_reason')" prop="undoReason" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fileResults" :label="$t('m.img_material')">
          <template slot-scope="scope" v-if="scope.row.fileResults && scope.row.fileResults.length>0">
            <img :src="scope.row.fileResults[0].url" class="img-thumb" @click="showPicPreviewDialog(scope.row.fileResults)">
          </template>
        </el-table-column>
        <el-table-column :label="$t('m.approval_time')" prop="createTime"></el-table-column>
        <el-table-column :label="$t('m.audit_status')" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 6">{{$t('m.approved')}}</span>
            <span v-if="scope.row.status == 7">{{$t('m.not_approved')}}</span>
            <span v-if="scope.row.status == 8">{{$t('m.platform_agree')}}</span>
            <span v-if="scope.row.status == 9">{{$t('m.agency_rejected')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('m.rejection_reason')" prop="refuseComplain" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="dialog.picture.show" :title="' '" @close="resetInfoForm" :append-to-body="true">
      <div v-loading="dialog.picture.loading">
        <el-carousel :autoplay="false" indicator-position="none" arrow="always">
          <el-carousel-item v-for="(item, index) in dialog.picture.fileList" :key="index">
            <img :src="item.url" v-if="item.type ===2 || item.type === 4" class="img-preview">
            <video :src="item.url" v-if="item.type ===0 || item.type ===1" controls="controls" type="video/mp4" class="img-preview"></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>

import { getAnchorContractLog } from '../../../api/anchor/management';

export default {
  name: 'sign-contract-dialog',

  data() {
    return {
      loading: {
        table: true,
        btn: false
      },
      tableData: [],
      show: false,
      model: {
        signId: null
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      dialog: {
       picture: {
         show: false,
         fileList: []
       },
      }
    };
  },

  methods: {
    showDialog(row) {
      console.log(row);
      this.model.signId = row.id;
      this.getTableData();
      this.show = true;
    },
    showPicPreviewDialog(row) {
      console.log(row);
      this.dialog.picture.fileList = row;
      this.dialog.picture.show = true;
    },
    resetInfoForm() {
      this.dialog.picture.fileList = [];
    },
    getTableData() {
      this.loading.table = true;
      getAnchorContractLog({
        query: this.model,
        pager: this.pager,
        sorter: this.sorter
      })
        .then(({ data }) => {
          this.tableData = data.data.list;
          this.loading.table = false;
        })
        .catch(error => {
          this.loading.table = false;
        });
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/anchor/dialogs/anchorAuditingLogDialog.vue